var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGbidownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 9.08643 6.49023",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 9.086426,
    height: 6.490234,
    fill: "none",
    customFrame: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u591A\\u8FB9\\u5F62 3",
    d: "M4.95278 0.585166L8.53562 5.70351C8.7676 6.0349 8.53052 6.49024 8.12601 6.49024L0.960328 6.49024C0.555816 6.49024 0.31874 6.0349 0.550712 5.70351L4.13355 0.585166C4.3326 0.300807 4.75373 0.300807 4.95278 0.585166Z",
    fill: "rgb(67,108,250)",
    fillRule: "evenodd",
    transform: "matrix(-1,0,0,-1,9.08643,6.49023)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\u591A\\u8FB9\\u5F62 3",
    d: "M4.95278 0.585166L8.53562 5.70351C8.59846 5.79327 8.62688 5.89213 8.62688 5.98857C8.62688 6.24817 8.42095 6.49024 8.12601 6.49024L0.960328 6.49024C0.665386 6.49024 0.459458 6.24817 0.459458 5.98857C0.459458 5.89213 0.487878 5.79327 0.550712 5.70351L4.13355 0.585166C4.3326 0.300807 4.75373 0.300807 4.95278 0.585166ZM4.54317 1.74379L1.92066 5.49024L7.16568 5.49024L4.54317 1.74379Z",
    fill: "rgb(112,112,112)",
    fillOpacity: 0,
    fillRule: "evenodd",
    transform: "matrix(-1,0,0,-1,9.08643,6.49023)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGbidownArrow);
export default __webpack_public_path__ + "static/media/gbidownArrow.764074fd712277d8657c3493d22893d2.svg";
export { ForwardRef as ReactComponent };